import { useEffect, useRef, useState } from 'react';
import type { Tela } from '@/shared/models/tela.model';

/**
 * usePresencaTela — estado de presença da tela no Jukebox cliente.
 *
 * Só o container de estado (tela / tvOnline / sincronizando + telaRef pra
 * leitura síncrona em callbacks de longa duração). Quem escreve nesse estado
 * é o `useJukebox` (composer): o fetch inicial e o `db_change` de `telas` no
 * `canal_tela_` cruzam presença com playlist/fila, então ficam no composer —
 * aqui é só o container.
 */
export interface PresencaTelaState {
  tela: Tela | null;
  setTela: React.Dispatch<React.SetStateAction<Tela | null>>;
  telaRef: React.MutableRefObject<Tela | null>;
  tvOnline: boolean;
  setTvOnline(v: boolean): void;
  sincronizando: boolean;
  setSincronizando(v: boolean): void;
}

export function usePresencaTela(): PresencaTelaState {
  const [tela, setTela] = useState<Tela | null>(null);
  const [tvOnline, setTvOnline] = useState(false);
  const [sincronizando, setSincronizando] = useState(false);

  const telaRef = useRef<Tela | null>(tela);
  useEffect(() => { telaRef.current = tela; }, [tela]);

  return { tela, setTela, telaRef, tvOnline, setTvOnline, sincronizando, setSincronizando };
}
